/* eslint-disable no-inline-comments */
import imported from 'react-imported-component';

// Guides
export const Guides = imported(() => import(/* webpackChunkName: "Guides" */ './Guides'));

// Pills
export const Pills = imported(() => import(/* webpackChunkName: "Pills" */ './Pills'));

// Páginas corporativas y términos legales
export const AboutFinect = imported(() => import(/* webpackChunkName: "AboutFinect" */ './AboutFinect'));
export const LegalTerms = imported(() => import(/* webpackChunkName: "Legal-LegalTerms" */ './Legal/LegalTerms'));
export const Terms = imported(() => import(/* webpackChunkName: "Legal-Terms" */ './Legal/Terms'));
export const EthicalCode = imported(() => import(/* webpackChunkName: "Legal-EthicalCode" */ './Legal/EthicalCode'));

// Escribir artículo desde perfil público
export const WriteArticle = imported(() => import(/* webpackChunkName: "WriteArticle" */ './Articles/WriteArticle/WriteArticle'));

//
export const Recap2024 = imported(() => import(/* webpackChunkName: "Recap2024" */ './Recap/Recap2024'));
export const Recap2025 = imported(() => import(/* webpackChunkName: "Recap2025" */ './Recap/Recap2025'));
